import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import MCWAHeaderLogo from '../../assets/logo.png';
import MCWAHeaderLogo21 from '../../assets/MCWALOGO2021_Edited.png';
import GearIcon from '../../assets/settings-icon.png';
import Button from '../button/Button';
import LogOutIcon from '../../assets/logout.png';
import api from '../../../api';


const Nav = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const menuClasses = classNames('lg:block flex items-end flex-col', {
    hidden: !isMenuOpen,
  });

  return (
    <div className="w-full bg-white py-4 px-1 lg:px-0">
      <nav className="flex items-center justify-between flex-wrap container mx-auto">
        <div className="flex items-center flex-shrink-0 mr-6">
          <a
            href="https://www.mcwa.com"
            target="_blank"
            rel="noopener noreferrer"
          ><div className='flex flex-row items-center justify-center'>
            <img
              // src={MCWAHeaderLogo}
              src={MCWAHeaderLogo21}
              style={{height: '60px', width: '80px'}}
              alt="Monroe County Water Authority Logo"
            />
            <div className='ml-2'>
              <h4 style={{fontFamily: 'Oswald, sans-serif', fontSize: '1.13rem'}}>Monroe County</h4>
              <h4 style={{fontFamily: 'Oswald, sans-serif', fontSize: '1.13rem'}}>Water Authority</h4>
            </div>
          </div>
            
          </a>
        </div>
        <div className="block lg:hidden">
          <button
            className="flex items-end p-3"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <svg
              className="fill-current h-8 w-8"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <title>Menu</title>
              <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
            </svg>
          </button>
        </div>
        <div className="w-full block flex flex-grow lg:items-center lg:w-auto justify-end">
          <div className="text-sm lg:flex-grow">
            <a
              href="https://www.mcwa.com"
              target="_blank"
              rel="noopener noreferrer"
              className="hidden lg:inline-block lg:mt-0 mr-4 mt-4 text-blue-dark"
            >
              &#60; Return to MCWA.com
            </a>
          </div>
          <div className={menuClasses}>
            <Link
              to="/user/dashboard"
              className="block mt-4 lg:inline-block lg:mt-0 mr-4 md:mr-6 lg:mr-8 uppercase text-lg font-semibold text-blue-dark hover:no-underline"
              style={{ fontFamily: 'Oswald, sans-serif', fontSize: '1.13rem' }}
            >
              My Account
            </Link>
            <Link
              onClick={() => setIsMenuOpen(false)}
              to="/user/profile"
              className="block mt-4 lg:inline-block lg:mt-0 mr-4 md:mr-6 lg:mr-8 uppercase text-lg font-semibold text-blue-dark hover:no-underline"
            >
              <div className="flex items-center">
                <span
                  style={{
                    fontFamily: 'Oswald, sans-serif',
                    fontSize: '1.13rem',
                  }}
                >
                  Settings
                </span>
                <img
                  className="ml-2"
                  src={GearIcon}
                  alt="Settings Icon"
                  style={{ width: '20px', height: '20px' }}
                />
              </div>
            </Link>
            <Button
              onClick={() => setIsMenuOpen(false)}
              iconUrl={LogOutIcon}
              onClick={() => {
                api.signout();
              }}
            >
              Log Out
            </Button>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Nav;
